import DetailPageLayout from "../Layout/DetailPageLayout";
import {
  ContentContainer,
  RegisterHeader,
  RegisterWrapper,
  RegisterEmailInput,
  NextButton,
  NextButtonText,
} from "./RegisterEmail.styles";
import { useState } from "react";
import { registerAtom } from "../../recoil/atoms";
import { useSetRecoilState } from "recoil";
import { TextM, TextS } from "../../common/text";
import { useCheckDuplicateUsername } from "./RegisterEmail.helpers";

const emailRegex =
  /^[A-Za-z0-9]([-_.]?[A-Za-z0-9])*@[A-Za-z0-9]([-_.]?[A-Za-z0-9])*\.[A-Za-z]{2,3}$/;

const RegisterEmail = () => {
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [validationMessage, setValidationMessage] = useState("");
  const setRegisterAtom = useSetRecoilState(registerAtom);
  const { mutate: checkDuplicateUsername } = useCheckDuplicateUsername();

  const onEmailChange = (e) => {
    const currentEmail = e.target.value;
    setEmail(currentEmail);

    if (!emailRegex.test(currentEmail)) {
      setValidationMessage("이메일 형식을 확인해주세요");
      setIsValidEmail(false);
    } else {
      setValidationMessage("사용가능한 이메일입니다");
      setIsValidEmail(true);
      setRegisterAtom((prev) => ({ ...prev, username: currentEmail }));
    }
  };

  const goNext = () => {
    if (isValidEmail && email.length !== 0) {
      checkDuplicateUsername({ username: email });
    }
  };

  return (
    <DetailPageLayout headerText={"아이디 입력"}>
      <ContentContainer>
        <RegisterHeader>
          <TextM>이메일이 아이디로 사용됩니다.</TextM>
        </RegisterHeader>
        <RegisterWrapper>
          <RegisterEmailInput
            onChange={onEmailChange}
            value={email}
            placeholder={"이메일을 입력해주세요"}
            variant="standard"
            helperText={
              email && <TextS color={"#f44b59"}>{validationMessage}</TextS>
            }
          ></RegisterEmailInput>
        </RegisterWrapper>

        <NextButton onClick={goNext} isValidEmail={isValidEmail}>
          <NextButtonText isValidEmail={isValidEmail}>다음</NextButtonText>
        </NextButton>
      </ContentContainer>
    </DetailPageLayout>
  );
};

export default RegisterEmail;
